import React from 'react';
import { TarotCardData } from '../types/tarot';

interface TarotCardProps {
  card: TarotCardData;
  isSelected?: boolean;
  isFlipped?: boolean;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  borderRadius?: 'sm' | 'md' | 'lg' | 'xl'; // Controls corner rounding
}

export const TarotCard: React.FC<TarotCardProps> = ({
  card,
  isSelected = false,
  isFlipped = false,
  onClick,
  className = '',
  disabled = false,
  borderRadius = 'xl' // Default to xl for backward compatibility
}) => {
  const isReversed = card.orientation === 'reversed';
  return (
    <div
      className={`
        relative cursor-pointer transition-all duration-300 transform
        ${!disabled ? 'hover:scale-105 hover:shadow-2xl' : 'cursor-not-allowed opacity-50'}
        ${isSelected ? 'ring-2 ring-purple-400 shadow-lg shadow-purple-500/50' : ''}
        ${className}
      `}
      onClick={!disabled ? onClick : undefined}
      style={{ perspective: '1000px' }}
    >
      {isReversed && isFlipped && (
        <div className="absolute top-1.5 left-1.5 z-30 bg-black/70 text-purple-100 uppercase text-[8px] tracking-[0.28em] px-1.5 py-[3px] rounded-full shadow-md">
          Reversed
        </div>
      )}
      <div
        className={`
          relative w-full h-full transition-transform duration-500 transform-style-preserve-3d
          ${isFlipped ? 'rotate-y-180' : ''}
        `}
      >
        {/* Card Back */}
        <div className="absolute inset-0 backface-hidden">
          <div className={`w-full h-full rounded-${borderRadius} overflow-hidden`}>
            <img 
              src={card.backImage}
              alt="Card back"
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
        </div>

        {/* Card Front */}
        <div className="absolute inset-0 backface-hidden rotate-y-180">
          <div
            className={`w-full h-full rounded-${borderRadius} overflow-hidden ${isReversed ? 'rotate-180' : ''}`}
          >
            <img 
              src={card.image} 
              alt={card.name}
              className={`w-full h-full object-cover ${isReversed ? 'rotate-180' : ''}`}
              loading="eager"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
